<template>
  <div>
    <!-- <v-card
      class="mx-4 mt-4"
      v-if="isStaff"
      shaped
      elevation="12"
      max-width="344"
      outlined
    >
      <v-list-item three-line>
        <v-autocomplete
          prepend-inner-icon="search"
          v-model="selectedService"
          :items="services"
          solo-inverted
          flat
          hide-details
          label="Select Service"
          
          @change="getSelectedService()"
        ></v-autocomplete>
        <v-btn
          class="mx-4"
          :style="getThemeStyle"
          @click="openGlobalDialogSlot()"
          ><v-icon>mdi-plus</v-icon></v-btn
        >
      </v-list-item>
    </v-card> -->
    <!-- <CardAlert class="mt-4 mx-4" color="#E65100"> -->
    <v-toolbar dark :style="{ background: '#004D40', color: 'white' }">
      <!-- <v-toolbar-title>{{ getCompanyLabels.services }}</v-toolbar-title> -->
      <v-autocomplete
        dense
        v-model="selectedService"
        :items="services"
        class="ml-4"
        flat
        hide-no-data
        hide-details
        :label="'Select ' + getCompanyLabels.services"
        solo-inverted
        @change="getSelectedService()"
      ></v-autocomplete>
      <v-btn
        color="#00695C"
        fab
        small
        :class="isMobile ? 'mb-6 ml-2' : 'ml-2'"
        dark
        @click="openGlobalDialogSlot()"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- </CardAlert> -->

    <GlobalDialogSlot
      :title="title"
      :dialog="dialog"
      @close-dialog="dialog = false"
    >
      <CreateService
        @service-created="getNewService"
        @exist="title = 'Item Exist'"
      ></CreateService>
    </GlobalDialogSlot>
  </div>
</template>

<script>
import productsAndServicesJs from "@/plugins/productsAndServices";
import CreateService from "@/modules/ProductsAndServices/CreateService.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";

export default {
  name: "Service",
  components: { GlobalDialogSlot, CreateService },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
  },
  async mounted() {
    this.$store.commit("setLoader", true);
    await this.getAllServices();
    this.$store.commit("setLoader", false);
  },
  data: () => ({
    title: "Create Service",
    services: [],
    selectedService: null,
    dialog: false,
  }),
  methods: {
    async getAllServices() {
      const services = await productsAndServicesJs.getAllServices();
      if (services.length > 0) {
        services.forEach((service) => {
          this.services.push({
            text: `${service.name} [${service.id}]`,
            value: service,
          });
        });
      }
    },
    getSelectedService() {
      this.$emit("service-selected", this.selectedService);
    },
    openGlobalDialogSlot() {
      this.title = "Create " + this.getCompanyLabels.services;
      this.dialog = true;
    },
    getNewService(service) {
      this.services.push({
        text: `${service.name} [${service.id}]`,
        value: service,
      });
      this.selectedService = service;
      this.$emit("service-selected", this.selectedService);
      this.dialog = false;
    },
  },
};
</script>

<style></style>
